// src/pages/BookingReviewPage.jsx
import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BookingReview from "../components/BookingReview";

const BookingReviewPage = () => {
  const [bookingData, setBookingData] = useState(null);

  useEffect(() => {
    // Load draft booking data (saved in previous step)
    const storedBooking = JSON.parse(localStorage.getItem("draftBooking") || "{}");
    if (storedBooking && storedBooking.property) {
      setBookingData(storedBooking);
    }
  }, []);

  return (
    <>
      <Header />
      <BookingReview bookingData={bookingData} />
      <Footer />
    </>
  );
};

export default BookingReviewPage;
